<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ 'admin.lifts.batchModal.titleEdit' | translate }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <app-input
            [formControl]="batchForm.controls.name"
            [showErrors]="showValidations"
            [placeholder]="'admin.lifts.batchModal.name' | translate"
            label="{{ 'admin.lifts.batchModal.name' | translate }}">
        </app-input>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="primary" class="create"
                    [disabled]="isLoading"
                    (click)="onBatchSave()">
            {{ 'admin.lifts.batchModal.button' | translate }}
        </app-button>
    </div>
</app-modal>
